<template>
    <v-card class="fillParent">
      <v-data-table :headers="heads" :items="propVals" hide-default-footer class="elevation-1 propTbl fillParent tunedScrollBar" 
                    :items-per-page=-1 fixed-header>
        <template v-slot:header.num="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
          <template v-slot:header.name="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
          <template v-slot:header.val="{ header }">
            {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
        </template>
        <template v-slot:header.act="{ header }">
            <v-tooltip bottom >
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="addItem()" id="orgAddBtn">add</v-icon>
                </template>
                <span>{{ $t( 'message.org_add_btn' ) }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="org.org_id">
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="editItem()" id="orgEditBtn">edit</v-icon>
                </template>
                <span>{{ $t( 'message.org_edit_btn' ) }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="org.org_id">
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="delItem()" id="orgDelBtn">delete</v-icon>
                </template>
                <span>{{ $t( 'message.org_del_btn' ) }}</span>
            </v-tooltip>
        </template>
        <template v-slot:item="{ item }">
            <tr>
                  <td>{{ item.num }}</td>
                  <td>{{ $t( 'message.add_org_' + item.name ) }}</td>
                  <td colspan="2">{{item.val}}</td>
            </tr>
        </template>
      </v-data-table>
    </v-card>
</template>

<script>
import{ conf } from '@/utils/confTruePLM';

export default {
  name: 'OrgInfo',
  props: {
      org: null
  },
  data () {
    return {
        heads: [
            { text: 'message.org_num_col', value: 'num', width: '10%' }, 
            { text: 'message.org_name_col', value: 'name' }, 
            { text: 'message.org_value_col', value: 'val' },
            { text: 'message.org_act_col', value: 'act', sortable: false, width: '15%' }
        ],
        globalState: this.$globalStore.state,
        propVals : [],
        props: [ 'title', 'uid', 'registered', 'invalid_from', 'address', 'email', 'url', 'phone', 'description', 'roles']
    };
  },
  watch: {
      org() 
      {
            this.updateInfo();
      }
  },
  methods: 
  {
      addItem()
      {
          this.$emit( 'addOrg' );
      },
      delItem()
      {
          this.$emit( 'delOrg' );
      },
      editItem()
      {
          this.$emit( 'editOrg' );
      },
      updateInfo()
      {
          this.propVals = [];
          
          if( !this.org )
              return;
          
          let ind = 0;
          this.props.forEach( ( prop ) =>
          {
              let val = this.org[ prop ];
              if( prop === 'roles' && val )
              {
                  let parts = val.split( ',' );
                  val = '';
                  parts.forEach( ( v ) => 
                  {
                      if( val !== '' )
                          val += ', ';
                      val += this.$utils.clearType( v );
                  });
              }
              else if( val && ( prop === 'registered' || prop === 'invalid_from' ) )
              {
                  val = this.$utils.getLocalDateFromUTC( val );
              }
              this.propVals.push( { num: ind++, name: prop, val: val } );                                        
          });       
      }
  },
  mounted: function() 
  { 
      this.updateInfo();
  },   
  beforeDestroy: function()
  {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .propTbl td
    {
        height: 30px;
    }        
</style>
